import React, { Component } from 'react';
import { APP_URL_API } from '../../../../setup/configs'
import Modal from '../../../../ui/modal/Modal';
import FileUploadActions from './FileUploadActions';
import axios from 'axios';
var fileDownload = require('js-file-download');

const styles = {
    fileinput: {
        width: '0.1px',
        height: '0.1px',
        opacity: 0,
        overflow: 'hidden',
        position: 'absolute',
        zIndex: -1
    },
    filelabel: {
        fontSize: '1em',
        fontWeight: 700,
        color: 'white',
        display: 'inline-block',
        padding: '.4em',
        margin: '0 0 .5em 0',
        cursor: 'pointer'
    }
}

class Regulations extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showModal: false,
            showAlertModal: false,
            file: null,
            accept: false,
            comment: '',
            currentDocument: {
                exist: false,
                filename: '',
                id: 0
            },
            documentAwaitingApproval: {
                exist: false,
                filename: '',
                id: 0,
                comment: ''
            }
        }
        this._onHandleApproveDocument = this._onHandleApproveDocument.bind(this);
    };

    onToggleModal = () => {
        if(this.state.showModal) {
            this.setState({
                showModal: false
            });
        } else {
            this.setState({
                showModal: true
            })
        }
    }

    onChange = (e) => {
        switch(e.target.type) {
            case "file":
                if(e.target.files[0].type === 'application/pdf') {
                    this.setState({
                        file: e.target.files[0]
                    })
                } else {
                    this.setState({
                        modalText: 'Du kan kun uploade pdf-filer',
                        showAlertModal: true,
                        showModal: false
                    });
                    e.target.value = "";
                }
                break;
            case "checkbox":
                this.setState({
                    [e.target.name]: e.target.checked
                })
                break;
            default:
                if(this.textarea.value.length <= 500) {
                    this.setState({
                        [e.target.name]: e.target.value
                    })
                }
        }
    }

    onSubmit = (e) => {
        e.preventDefault();
        if(this.state.currentDocument.exist && !this.state.comment) {
            this.setState({
                modalText: 'Du skal angive ændringer i forhold til de tidligere vedtægter',
                showAlertModal: true,
                showModal: false
            });
            return false;
        }
        if((this.props.user.type==="admin" && !this.state.file) ||
                (this.props.user.type==="user" && (!this.state.file || !this.state.accept))) {
            this.setState({
                modalText: 'Du skal vælge en fil og/eller godkende betingelserne',
                showAlertModal: true,
                showModal: false
            });
            return false;
        }
        this.fileInput.value = "";
        this.setState({
            showModal: false
        },this.props.onHandleFileUpload('regulations', this.state.file, this.state.comment));
    }

    onRemoveFile = (e) => {
        this.setState({
            file: null
        }, this.props.onHandleFileUpload('regulations'))
    }

    _onHandleApproveDocument = (id, curId) => {
        let documentAwaitingApproval = this.state.documentAwaitingApproval;
        documentAwaitingApproval.exist = false;
        documentAwaitingApproval.filename = '';
        documentAwaitingApproval.id = 0;
        this.setState({
            documentAwaitingApproval: documentAwaitingApproval
        }, this.props.onHandleApproveDocument(id, curId, 'regulations'))
    }

    _onHandleRejectDocument = (id) => {
        let documentAwaitingApproval = this.state.documentAwaitingApproval;
        documentAwaitingApproval.exist = false;
        documentAwaitingApproval.filename = '';
        documentAwaitingApproval.id = 0;
        this.setState({
            documentAwaitingApproval: documentAwaitingApproval
        }, this.props.onHandleDeleteDocument(id, 'regulations'))
    }

    _onHandleDeleteDocument = (id) => {
        let currentDocument = this.state.currentDocument;
        currentDocument.exist = false;
        currentDocument.filename = '';
        currentDocument.id = 0;
        this.setState({
            currentDocument: currentDocument
        }, this.props.onHandleDeleteDocument(id, 'regulations'))
    }

    _onHandleDownloadFile = (id, filename) => {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token, 'Content-Type' : 'application/pdf'};
        const url = APP_URL_API + 'files/' + id + '/download';

        this.serverRequest =
            axios
                .get(url, {responseType: 'arraybuffer', headers: config})
                .then(function(response) {
                    fileDownload(response.data, filename);
                })
    }

    componentDidMount() {
        if(this.props.documents) {
            let documentAwaitingApproval = this.state.documentAwaitingApproval;
            let currentDocument = this.state.currentDocument;
            this.props.documents.forEach(function(document, index) {
                if(document.approved_at === '') {
                    documentAwaitingApproval.exist = true;
                    documentAwaitingApproval.filename = document.filename;
                    documentAwaitingApproval.id = document.id;
                    documentAwaitingApproval.comment = document.comment;
                }
                if(document.approved_at !== '') {
                    currentDocument.exist = true;
                    currentDocument.filename = document.filename;
                    currentDocument.id = document.id;
                }
            })
            this.setState({
                documentAwaitingApproval: documentAwaitingApproval,
                currentDocument: currentDocument,
                filesExist: true,
            })
        }
    }

    render() {
		return(
			<div className="mtb-4">
                <h2>Vedtægter</h2>
                <div className="flexbox">
                    <div className="pr-2">
                        <CurrentDocument
                            _onHandleDeleteDocument={this._onHandleDeleteDocument}
                            _onHandleDownloadFile={this._onHandleDownloadFile}
                            document={this.state.currentDocument}
                            user={this.props.user} />
                        {!this.state.currentDocument.exist && <FileUploadActions
                            file={this.props.file}
                            onToggleModal={this.onToggleModal}
                            onRemoveFile={this.onRemoveFile} />}
                    </div>
                    {this.state.currentDocument.exist && !this.state.documentAwaitingApproval.exist &&
                    <div>
                        <h4 className="pb-1">Upload nye vedtægter</h4>
                        <FileUploadActions
                                file={this.props.file}
                                onToggleModal={this.onToggleModal}
                                onRemoveFile={this.onRemoveFile} />
                    </div>}
                    <ApprovalPanel
                        _onHandleApproveDocument={this._onHandleApproveDocument}
                        _onHandleRejectDocument={this._onHandleRejectDocument}
                        _onHandleDownloadFile={this._onHandleDownloadFile}
                        document={this.state.documentAwaitingApproval}
                        user={this.props.user}
                        currentDocument={this.state.currentDocument} />
                </div>
                <Modal visible={this.state.showModal}>
                    <h4>Vedtægter</h4>
                    <div>
                        <input style={styles.fileinput} type="file" id="regulations" name="regulations" onChange={this.onChange} ref={ref=> this.fileInput = ref}/>
                        <label htmlFor="regulations" style={styles.filelabel} className="upload">{this.state.file ? this.state.file.name : 'Vælg fil'}</label>
                        <div className="form-helper-label">Kun PDF-filer på max 20 MB tilladt</div>
                    </div>
                    {this.state.currentDocument.exist && <div>
                        <p>Angiv ændringer i forhold til de tidligere vedtægter. Oplysningerne er påkrævet.</p>
                        <textarea ref={ref => (this.textarea = ref)} value={this.state.comment} name="comment" onChange={this.onChange} style={{width: '100%', height: '100px'}} />
                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                            {this.state.comment.length == 500 && <span style={{marginTop: '0', fontSize: '.75em', textAlign:'right', color: 'red'}}>Du har indtastet det maksimale antal tegn.</span>}  
                            <span style={{marginTop: '0', fontSize: '.75em', textAlign:'right', flexGrow: '1'}}>Max 500 tegn</span>
                        </div>
                    </div>}
                    {this.props.user.type==="user" && <div style={{marginTop: '1em'}}>
                        <label style={{fontSize: '1em', padding: 0, margin: 0}}>
                        <input type="checkbox" name="accept" onChange={this.onChange} checked={this.state.accept} />
                        Jeg erklærer hermed på tro og love, at de indberettede oplysninger er korrekte og i overensstemmelse med de gældende regler for anerkendte trossamfund, samt at jeg i henhold til § 7, stk. 2, nr. 4, i lov nr. 1533 af 19. december 2017 om trossamfund uden for folkekirken er berettiget til på trossamfundets/menighedens vegne at foretage indberetningen.
                        </label>
                        <p>By-, Land- og Kirkeministeriet gør opmærksom på, at de indberettede oplysninger vises på Trossamfundsregistrets hjemmeside, jf. § 21, stk. 1 og 2, jf. § 11, i lov nr. 1533 af 19. december 2017 om trossamfund uden for folkekirken.</p>
                    </div>}
                    {this.props.user.type==="admin" &&
                        <div style={{marginTop: '1em'}}>
                            Der foreligger dokumentation i ESDH-systemet for, at trossamfundet/menigheden har anmodet By-, Land- og Kirkeministeriet om at indberette på trossamfundets/menighedens vegne.
                        </div>
                    }
                    <div style={{marginTop: '1em'}}>
                        <button type="button" className="button" onClick={() => this.onToggleModal()}>Luk</button>
                        <button type="button" className="button" onClick={this.onSubmit}>Gem</button>
                    </div>
                </Modal>
                <Modal visible={this.state.showAlertModal}>
                    <p>{this.state.modalText}</p>
                    <div style={{marginTop: '3em', textAlign: 'right', minWidth: '400px'}}>
                        <button type="button" className="button" onClick={() => this.setState({showAlertModal: false, showModal: true})}>Ok</button>
                    </div>
                </Modal>
            </div>
      	);
	}
}

const ApprovalPanel = (props) => {
    if(props.document.exist) {
        if(props.user.type==='admin') {
            return(
                <div>
                    <div className="approvalPanel">
                        <b>Vedtægter der afventer KM godkendelse</b>
                        <div className="approvalPanel__actions">
                            <div style={{cursor: 'pointer'}} onClick={() => props._onHandleDownloadFile(props.document.id, props.document.filename)}>{props.document.filename}</div>
                            <div>
                                <img src="/images/assets/vhvid.svg" alt="Godkend"
                                    onClick={() => { if (window.confirm('Er du sikker på at du vil godkende vedtægter?')) props._onHandleApproveDocument(props.document.id, props.currentDocument.id) }} style={{cursor: 'pointer'}} /></div>
                            <div>
                                <img src="/images/assets/krydshvid.svg" alt="Afvis"
                                    onClick={() => { if (window.confirm('Hvis du afviser bliver filen slettet permanent')) props._onHandleRejectDocument(props.document.id) }} style={{cursor: 'pointer'}} /></div>
                        </div>
                        <div><i>{props.document.comment}</i></div>
                    </div>
                </div>
            )
        } else {
            return(
                <div className="flexbox">
                    <div>
                        <h4>Vedtægter der afventer KM godkendelse</h4>
                        <div style={{cursor: 'pointer'}} className="ptb-1" onClick={() => props._onHandleDownloadFile(props.document.id, props.document.filename)}>{props.document.filename}</div>
                    </div>
                    <div className="prl-2">
                        <div className="approvalMsg">Vedtægterne afventer By-, Land- og Kirkeministeriets godkendelse, og vises derfor ikke på hjemmesiden.</div>
                    </div>
                </div>
            )
        }
    } else {
        return null;
    }
}

const CurrentDocument = (props) => {
    if(props.document.exist) {
        return(
            <div className="currentDocumentPanel">
                <h4>Nuværende vedtægter</h4>
                <div className="currentDocument__actions">
                    <div style={{cursor: 'pointer'}} onClick={() => props._onHandleDownloadFile(props.document.id, props.document.filename)}>{props.document.filename}</div>
                    {props.user.type==="admin" && <div><img src="/images/assets/kryds.svg" alt="Slet" onClick={() => { if (window.confirm('Er du sikker på at du vil slette filen?')) props._onHandleDeleteDocument(props.document.id) }} style={{cursor: 'pointer'}} /></div>}
                </div>
            </div>
        )
    } else {
        return null;
    }
}

export default Regulations;


// WEBPACK FOOTER //
// ./src/modules/admin/organization/sections/Regulations.js